import React from 'react';

interface IPriceLoaderProps {
  fill: string;
  width?: number;
  height?: number;
}

const PriceLoader = ({
                       fill,
                       width = 200,
                       height = 200
                     }: IPriceLoaderProps) => {
  return (
    <svg
      width={width + 'px'}
      height={height + 'px'}
      viewBox='0 0 100 100'
      preserveAspectRatio='xMidYMid'
    >
      <path
        d='M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50'
        fill={fill}
        stroke='none'
        transform='rotate(12.5366 50 51)'
      >
        <animateTransform
          attributeName='transform'
          type='rotate'
          dur='1s'
          repeatCount='indefinite'
          keyTimes='0;1'
          values='0 50 51;360 50 51'
        ></animateTransform>
      </path>
    </svg>
  );
};

export default PriceLoader;
